import React, {useState} from 'react';
import './growBusiness.scss';
import {CourseCard, CourseCardProps} from "../../../../components/course-card/CourseCard";
import GROW_IMAGE1 from "../../../../assets/dashboard/growing_image.svg";
import {Button} from "../../../../components";

const GrowBusiness = () => {

    const [courses] = useState<CourseCardProps[]>([
        {
            image: GROW_IMAGE1,
            heading: "Business Planning checklist",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: "test"
        },
        {
            image: GROW_IMAGE1,
            heading: "How to Write a Business Plan",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: true,
            link: "test"
        },
        {
            image: GROW_IMAGE1,
            heading: "Market Research & Analysis",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: "test"
        },
    ])
    return (
        <div className={'grow-business'}>
            <div className={'grow-business_courses'}>
                <div className={'grow-business_courses_top'}>
                    <h1>Courses</h1>
                </div>
                <div className={'grow-business_courses_bottom'}>
                    {courses.map(({image, heading, description, isDone, link}) => (
                        <CourseCard image={image} heading={heading} description={description} isDone={isDone}
                                    link={link}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default GrowBusiness;
